import React from 'react'
import PropTypes from 'prop-types'
import { useGetPresignedurlAttachments } from 'hooks/usePayments'
import { Attachments } from 'components/Invoice/Attachments'
export function AttachmentPayments(props) {
  const { cantAttachments, appId, paymentId } = props
  const responseQuery = useGetPresignedurlAttachments({
    paymentId,
    appId,
    config: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: !!cantAttachments,
      cacheTime: 2400000
    }
  })
  return (
    <Attachments
      dataAttachments={{
        ...responseQuery,
        cantAttachments,
        attachments: responseQuery.data ?? []
      }}
    />
  )
}

AttachmentPayments.propTypes = {
  cantAttachments: PropTypes.number.isRequired,
  paymentId: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired
}
